import { render, staticRenderFns } from "./CurrencyDetailView.vue?vue&type=template&id=39fa0a1a&"
import script from "./CurrencyDetailView.vue?vue&type=script&lang=js&"
export * from "./CurrencyDetailView.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDetailView.vue?vue&type=style&index=0&id=39fa0a1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VContainer,VIcon,VLayout,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VTab,VTabs})
